



























































import _ from 'lodash'
import moment from 'moment'
import { Component, Prop } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ISchedule } from '@/store/modules/views/schedule/states'
import DetailLogDialog from '@/components/logs/DetailLog.vue'
import { ICaregiver } from '@/store/modules/views/caregiver/states'

@Component({
  components: {
    DetailLogDialog,
  },
})
export default class MainLog extends VueExtendedBaseComponent {
  @Prop() public lists!: ISchedule[]
  @Prop() public careGivers!: {[careGiverId: string]: ICaregiver}

  public title = 'รายละเอียด'
  public detailDialog = false
  public detail = []

  get listGrouping() {
    const today = moment().format('YYYY-MM-DD')
    const groups = _(
      _.reduce(this.lists, (result, item) => {
        if (item.startDate > today) {
          return result
        }
        result.push({
          ...item,
          groupName: `${item.startDate}_${item.startTime}_${item.endDate}_${item.endTime}`,
        })
        return result
      }, [] as Array<ISchedule & {groupName: string}>),
    )
    .orderBy(['groupName'], ['desc'])
    .groupBy('groupName')
    .value()

    _.forEach(groups, (group, index) => {
      groups[index] = _.uniqBy(group, 'userId')
    })

    _.forEach(groups, (group, index) => {
      _.forEach(group, (item, subindex) => {
        const key = 'caregiverCount'
        groups[index][subindex][key] =  _(groups[index]).uniqBy('userId').size() || 0
        const cargiver = this.careGivers[item.userId]
        item.logs = item.logs.map((subitem, logIndex) => {
          return {
            ...subitem,
            id: logIndex,
            caregiverName: cargiver ? this.mapFullName(cargiver) : '',
          }
        })
      })
    })
    return groups
  }

  private displayDate(startDate, endDate) {
    if (startDate === endDate) {
      return this.localeDate(startDate)
    } else {
      return this.localeDate(startDate, 'll') + ' - ' + this.localeDate(endDate, 'll')
    }
  }

  private openDialog(detail, date, time) {
    this.detail = detail
    this.title = `${date} (${time})`
    this.detailDialog = true
  }
}
